import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { OverlayForm, TGSFormControl, AutoUnsubscribe, Subscription } from '../../../models';
import { FormBuilder } from '@angular/forms';
import * as lodash from 'lodash';

@Component({
  selector: 'app-tgs-form',
  templateUrl: './tgs-form.component.html',
  styleUrls: ['./tgs-form.component.css']
})
@AutoUnsubscribe
export class TgsFormComponent extends OverlayForm implements OnInit, OnChanges {

  @Input() controls: TGSFormControl[] = [];
  @Input() resetButton: boolean;
  @Input() teams = [];
  @Input() conferenceList = [];
  @Input() isVideo: boolean;
  @Input() isSafeSport: boolean = false;
  @Input() isCollegeRecruitingCommunication: boolean = false;

  @Input() teamList = [];

  @Input() resetButtonTitle;
  @Input() searchButtonTitle;

  sub: Subscription;

  constructor(
    public fb: FormBuilder
  ) {
    super(fb);
  }

  ngOnInit() {
  }

  ngOnChanges(data) {
    if (data.controls && this.controls) {
      const group: any = {};
      this.controls.forEach(control => {
        group[control.name] = [null, control.validators || []];
      });
      this.form = this.fb.group(group);
      setTimeout(() => {
        this.reset();
      });

      if (!this.isCollegeRecruitingCommunication && group.teamTypeID && group.teamID) {
        this.sub = this.form.controls.teamTypeID.valueChanges.subscribe(typeID => {
          this.controls.find(c => c.name === 'teamID').options = this.teams.filter(t => t.teamTypeID === +typeID)
            .map(t => ({ text: t.teamName, value: t.teamID }));
        });
      }

      if (this.isCollegeRecruitingCommunication && group.teamTypeID && group.teamGender && group.teamID) {
        this.sub = this.form.controls.teamGender.valueChanges.subscribe(teamGender => {
          this.controls.find(c => c.name === 'teamID').options = teamGender !== 'b' ? (this.teams.filter(t => (t.teamTypeID === +this.form.controls.teamTypeID.value) && (t.teamGender ? t.teamGender.toLowerCase() == teamGender : false))
            .map(t => ({ text: t.teamName, value: t.teamID }))) : (this.teams.filter(t => (t.teamTypeID === +this.form.controls.teamTypeID.value)).map(t => ({ text: t.teamName, value: t.teamID })));
        });
      }

      if (group.collegeDivisionID && group.collegeconferenceID) {

        this.sub = this.form.controls.collegeDivisionID.valueChanges.subscribe(collegeDivisionID => {
          for (let conference of this.conferenceList) {
            this.controls[2].options.push({ text: conference.conferencename, value: conference.collegeconferenceID });
          }
          this.controls.find(c => c.name === 'collegeconferenceID').options = this.conferenceList.filter(t => t.collegedivisionID === +collegeDivisionID)
            .map(t => ({ text: t.conferencename, value: t.collegeconferenceID }));
        });
      }
    }
  }

  //for video
  changedvalue(event, control) {
    let eventValue = event.target.value;
    //console.log("eventValue=>", eventValue);
    if (this.controls && eventValue) {
      const group: any = {};
      this.controls.forEach(control => {
        group[control.name] = [null, control.validators || []];
      });

      if (this.isVideo && group && group.teamGender && this.teamList.length > 0 && control.name == "teamGender") {
        this.controls.find(c => c.name === 'teamID').options = this.teamList.filter(t => t.teamGender === eventValue)
          .map(t => ({ text: t.name, value: t.id }));
      }
      if (this.isSafeSport && group && group.teamGender && this.teamList.length > 0 && control.name == "teamGender") {
        this.controls.find(c => c.name === 'teamID').options = lodash.uniqBy(this.teamList.filter(t => t.teamGender === eventValue)
          .map(t => ({ text: t.name, value: t.id })), 'value');
      }

    }
  }

  groupedOptions(options) {
    return Object.values(lodash.groupBy(options, 'group'));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tgs-form/tgs-form.component.ts